import type { AdminUser } from "@glow-price/shared";

import { apiRequest } from "./client";

export type AdminLoginResult = {
  token: string;
  expiresAt: number;
  displayName: string | null;
  username: string;
};

export function adminLogin(input: { username: string; password: string }) {
  return apiRequest<AdminLoginResult>("/api/admin/auth/login", {
    method: "POST",
    body: input,
  });
}

// Phase 6A widened `/api/admin/auth/me` to return the full safe row alongside
// the legacy `adminUserId` field. We keep both so old callers still compile.
export type AdminMeResult = {
  adminUserId: string;
  adminUser: AdminUser | null;
};

export function adminMe() {
  return apiRequest<AdminMeResult>("/api/admin/auth/me");
}

export function adminChangeOwnPassword(input: { oldPassword: string; newPassword: string }) {
  return apiRequest<{ ok: true }>("/api/admin/auth/me/password", {
    method: "PATCH",
    body: input,
  });
}
